import React from "react";
import Tabs from "components/Tabs";
import { WHITE_TAB_STYLES } from "components/Tabs";
import { STATE_KEYS } from "utils/constants/state";
import { FEATURE_TABS } from "utils/constants/feature";
import startCase from "lodash/startCase";
import FeatureTablePreviewContainer from "components/FeaturesSection/FeatureTablePreviewContainer";
import SectionHeader from "components/SectionHeader";
import ENTITIES from "../common/constants/entity";
import { BUILDER_INTENT, BUILDER_ENTITY } from "utils/constants/builder";
import { useRemainingEntityRequiredParents } from "utils/builder";
// import FeatureGroupsFormContainer from "./FeatureGroupsFormContainer";
// import FeaturesFormContainer from "./FeaturesFormContainer";
import SlimCTA from "components/SlimCTA";
import { useAppManifestSectionDestination } from "utils/hooks";
import { SECTIONS } from "../utils";
import { BUTTON_TAGS } from "utils/constants/ui";
import { useRouter } from "next/router";
import { useFormikContext } from "formik";
import set from "lodash/set";
import get from "lodash/get";
import { formFactorAction } from "utils/view";

const PARENT_REQUIRED_SUBHEADER =
  "Your page needs to have a pricing table before you can list features to compare. Head back your builder and add a pricing table block and then select which products you want to compare.";
const MIN_PRODUCT_REQUIRED =
  "Your pricing table needs to have at least one product added to it before you can list features to compare. Head back your builder and add a product to your pricing table.";

const FeaturesContainer = ({ pathPrefix, layout }) => {
  const remaining = useRemainingEntityRequiredParents(
    ENTITIES.FEATURE_COMPARISON
  );
  const router = useRouter();
  const { values, setValues } = useFormikContext();
  const pricingLayout = get(values, STATE_KEYS.MANIFEST.PRICING_LAYOUT);
  const builderDestination = useAppManifestSectionDestination(
    SECTIONS.PAGE_BUILDER
  );
  let content;
  const hasAllRequiredParentEntities = remaining.length === 0;
  const hasMinProductsInLayout = pricingLayout.length > 0;

  if (hasAllRequiredParentEntities && hasMinProductsInLayout) {
    const tabProps = {
      minWidth: false,
      equalWidth: false,
      pathPrefix,
      customStyles: WHITE_TAB_STYLES,
      customClasses: {
        tabs: {
          list:
            "list ma0 pa0 nowrap center overflow-x-auto absolute top-0 left-0 right-0 ph3"
        }
      },
      tabs: [
        // {
        //   name: `${startCase(FEATURE_TABS.GROUP)}s`,
        //   id: FEATURE_TABS.GROUP,
        //   node: <FeatureGroupsFormContainer />
        // },
        // {
        //   name: "Features",
        //   id: FEATURE_TABS.ALL,
        //   node: <FeaturesFormContainer />
        // },
        {
          name: startCase(FEATURE_TABS.PREVIEW),
          id: FEATURE_TABS.PREVIEW,
          node: <FeatureTablePreviewContainer layout={layout} />
        }
      ]
    };

    content = (
      <div className="w-100 bg-white overflow-y-scroll-ns h-100">
        <SectionHeader
          header="Feature comparison groups"
          subheader="Add and group each of your product features to help your customers compare their options."
          copy={`Drag and drop features to update their order, and when you're ready, ${formFactorAction().toLowerCase()} save.`}
        />
        <Tabs {...tabProps} />
      </div>
    );
  } else {
    const ctaCopyProps = {};
    if (!hasAllRequiredParentEntities) {
      ctaCopyProps.header = "Missing block";

      ctaCopyProps.subheader = PARENT_REQUIRED_SUBHEADER;
    } else if (!hasMinProductsInLayout) {
      ctaCopyProps.header = "Missing products";
      ctaCopyProps.subheader = MIN_PRODUCT_REQUIRED;
    }

    content = (
      <div className="measure center mw8 w-100 pt4">
        <SlimCTA
          {...ctaCopyProps}
          customClasses={{
            container:
              "w-100 flex flex-column justify-between ba br2 hairline-1 pa3 items-start bg-white",
            actionsWrapper: "pt2"
          }}
          actions={[
            {
              copy: "Add block",
              tag: BUTTON_TAGS.BUTTON,
              onClick: () => {
                const updatedValues = { ...values };
                set(
                  updatedValues,
                  STATE_KEYS.EDITOR.INTENT,
                  BUILDER_INTENT.ENTITY_ADD
                );
                set(updatedValues, STATE_KEYS.EDITOR.VISIBILITY_PANEL, true);
                set(
                  updatedValues,
                  STATE_KEYS.EDITOR.ACTIVE_BLOCK,
                  BUILDER_ENTITY.ENTITY_ADD
                );
                setValues(updatedValues);
                router.push(builderDestination);
              }
            }
          ]}
        />
      </div>
    );
  }

  return content;
};

export default FeaturesContainer;
